import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ToggleOff = (props) => (
  <Icon viewBox="0 0 9 2" {...props}>
    <g>
      <path d="M8 2H1c-.6 0-1-.4-1-1 0-.5.4-1 1-1h7c.5 0 1 .4 1 1s-.4 1-1 1z" className="st0" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ToggleOff;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ToggleOff.js